export default __webpack_public_path__ + "18dbd8a047804372c583ee27dba2f3f5.svg";